<script setup lang="ts">
import type { LocationQueryRaw } from 'vue-router';

type CamPortalURL = Parameters<typeof useCamPortalURL>[0];
type MarPortalURL = Parameters<typeof useMarPortalURL>[0];
type HelpPortalURL = Parameters<typeof useHelpPortalURL>[0];
type LegalPortalURL = Parameters<typeof useLegalPortalURL>[0];

const props = defineProps<{
	label: string;
	portal: 'camPortal' | 'mar' | 'help' | 'legal';
	to: string;
	query?: string | LocationQueryRaw;
}>();

const parsedQuery = computed<LocationQueryRaw | undefined>(() => {
	if (!props.query) { return undefined; }

	if (typeof props.query === 'string') {
		try {
			return JSON.parse(props.query);
		}
		catch {
			return undefined;
		}
	}

	return props.query;
});

const basePath = computed(() => {
	switch (props.portal) {
		case 'camPortal':
			return props.to?.trim()
				? useCamPortalURL(props.to as CamPortalURL)
				: useCamPortalURL();
		case 'mar':
			return props.to?.trim()
				? useMarPortalURL(props.to as MarPortalURL)
				: useMarPortalURL();
		case 'help':
			return props.to?.trim()
				? useHelpPortalURL(props.to as HelpPortalURL)
				: useHelpPortalURL();
		case 'legal':
			return props.to?.trim()
				? useLegalPortalURL(props.to as LegalPortalURL)
				: useLegalPortalURL();
		default:
			return '';
	}
});

const resolvedUrl = computed(() => {
	if (!basePath.value) { return ''; }

	if (!parsedQuery.value) { return basePath.value; }

	const query = new URLSearchParams();

	Object.entries(parsedQuery.value).forEach(([key, value]) => {
		if (value == null) { return; }

		if (Array.isArray(value)) {
			value.forEach((item) => {
				if (item != null) { query.append(`${key}[]`, String(item)); }
			});

			return;
		}

		query.append(key, String(value));
	});

	const queryString = query.toString();

	return queryString
		? `${basePath.value}?${queryString}`
		: basePath.value;
});

// TODO ŽAN - NAREDI GLOBALNO
// const { isAuthenticated } = storeToRefs(useUserSession());
// const { register } = getBuiltUrl();

const isAuthenticated = true;
const register = '#';
</script>

<template>
	<HmButton
		label="Register now"
		icon="arrow-right"
		variant="solid"
		:to="register"
		v-if="!isAuthenticated"
	/>
	<HmButton
		:label="props.label"
		variant="solid"
		icon="arrow-right"
		:to="resolvedUrl || ''"
		v-else
	/>
</template>
